export default "__VITE_ASSET__D66AVEdl__"